import React from "react";
import { Typography } from "@bca/ui-library";

import TachometerFastSVG from "./Icons/TachometerFastSVG";
import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";

interface WarrantedMileageProps {
  mileCount?: number;
  mileageWarranted:
    | "Warranted"
    | "Yes"
    | "Not warranted"
    | "No"
    | "Incorrect"
    | "Unknown";
}

const WarrantedMileage: React.FunctionComponent<WarrantedMileageProps> = ({
  mileCount,
  mileageWarranted,
}) => {
  const formattedMileCount = mileCount
    ? `${mileCount.toLocaleString()} mi`
    : "-";

  const getDetailMileage = (
    mileageWarranted: WarrantedMileageProps["mileageWarranted"]
  ) => {
    let mileageWarrantedText = "-";
    switch (mileageWarranted) {
      case "Yes":
        mileageWarrantedText = "Warranted mileage";
        break;
      case "Warranted":
        mileageWarrantedText = "Warranted mileage";
        break;
      case "Not warranted":
        mileageWarrantedText = "Not warranted";
        break;
      case "No":
        mileageWarrantedText = "Not warranted";
        break;
      case "Incorrect":
        mileageWarrantedText = "Incorrect mileage";
        break;
      case "Unknown":
        mileageWarrantedText = "-";
        break;
      default:
        mileageWarrantedText = "-";
    }

    return mileageWarrantedText;
  };

  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        <TachometerFastSVG width="24px" height="24px" />
        <Typography
          m={0}
          variant="h6"
          fontWeight="semiBold"
          color="footer-blue"
        >
          {formattedMileCount}
        </Typography>
      </KeyDecisionMakerText>
      <Typography
        variant="body-small"
        color="grey-blue"
        m={0}
        textAlign="center"
      >
        {getDetailMileage(mileageWarranted)}
      </Typography>
    </KeyDecisionMakerContainer>
  );
};

export default WarrantedMileage;
